import script from "./allorder.vue?vue&type=script&setup=true&lang=js"
export * from "./allorder.vue?vue&type=script&setup=true&lang=js"

import "./allorder.vue?vue&type=style&index=0&id=58b422a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b422a1"]])

export default __exports__